import { TagSchema } from "@redotech/redo-model/tag";
import * as z from "zod/v4";

export const updateOrderTrackingShipment = {
  name: "updateOrderTrackingShipment" as const,
  input: z.object({
    shipmentId: z.string(),
    tags: z.array(TagSchema).nullish(),
    internalNote: z.string().nullish(),
  }),
  output: z.null(),
};
